import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, Query, QueryFn} from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  name = 'Angular';
  view: any[];
  view2: any[];
  viewpichart: any[];
  width: number = 250;
  height: number = 350;
  fitContainer: boolean = false;
  showXAxis = true;
  showYAxis = true;
  //legendPosition = LegendPosition.Right;
  gradient = true;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Country';
  showYAxisLabel = true;
  yAxisLabel = 'Sales';
  timeline = true;
  doughnut = true;
  // options
  legendTitle = 'Legend';
  tooltipDisabled = false;
  showText = true;
  showGridLines = true;
  innerPadding = '10%';
  barPadding = 8;
  groupPadding = 16;
  roundDomains = false;
  maxRadius = 10;
  minRadius = 3;
  showSeriesOnHover = true;
  roundEdges: boolean = true;
  animations: boolean = true;
  xScaleMin: any;
  xScaleMax: any;
  yScaleMin: number;
  yScaleMax: number;
  showDataLabel: boolean = true;
  noBarWhenZero: boolean = true;
  trimXAxisTicks: boolean = true;
  trimYAxisTicks: boolean = true;
  rotateXAxisTicks: boolean = true;
  maxXAxisTickLength: number = 16;
  maxYAxisTickLength: number = 16;
  strokeColor: string = '#FFFFFF';
  strokeWidth: number = 2;
  colorScheme = {
    domain: ['#9370DB', '#87CEFA', '#FA8072', '#FF7F50', '#90EE90', '#9370DB']
  };
  //pie
  showLabels = true;
  
  colors = ['#194759', '#F0552F'];

  step = 0;
  currentuser: any;
  client: any;
  audit: any[] = [];
  clientmodule: any[] = [];
  auditbymodule: any[] = [];
  latestdate: string;
  auditbymodulecat: any[] = [];
  auditmodulelabel: any[] = [];
  modulewithaudit: any;
  lastauditbymodule: any[] = [];
  categories: any[] = [];
  auditbymodulescore: any[] = [];
  startdate: any;
  // lastaudittotalscore: any;
  // average: number;
  allLastaudit: any[] = [];
  id: any;
  branches: any[] = [];
  HideModules: boolean=false;



  // branchesAudits:any[] = [];
  // auditofbranch: any[] = [];
  // lastauditbymodulebranch: any[]=[];
  // dataSource: any;

  
  // setStep(index: number) {
  //   this.step = index;
  // }

  // nextStep() {
  //   this.step++;
  // }

  // prevStep() {
  //   this.step--;
  // }
 

  constructor(private AngularFirestore: AngularFirestore,private GeneralService: GeneralService, public datepipe: DatePipe, public router: Router) {
    this.currentuser = JSON.parse(localStorage.getItem("currentuser"));
    console.log(this.currentuser);
    const userid =localStorage.getItem("userid");
    

    if(userid){
      this.id = localStorage.getItem("userid");
      console.log(this.id);
    }else{
      if(this.currentuser.role == 'admin'){
        const navigation = this.router.getCurrentNavigation();
        const user = navigation.extras.state;
        this.id = user;

        this.currentuser.clientid = user;
      localStorage.setItem("currentuser",JSON.stringify(this.currentuser));
        localStorage.setItem("userid", this.id);
        this.getclientbyid();

      }else{
        this.id = this.currentuser.clientid;
      }
    }
  }
   
 
  getStyledWords(sentence: string): { word: string, color: string }[] {
    if (!sentence) return [];

    const words = sentence.split(' ');  // Split the sentence into words

    // Return an array of words with alternating colors
    return words.map((word, index) => ({
      word,
      color: this.colors[index % this.colors.length]
    }));
  }

  // private cachedSentence: string;
  // private cachedStyledSentence: SafeHtml;
  
  // getStyledSentence(sentence: string): SafeHtml {
  //   if (!sentence) return '';
    
  //   if (this.cachedSentence === sentence) {
  //     return this.cachedStyledSentence;  // Return the cached result
  //   }
  
  //   const colors = ['#194759', '#F0552F'];  // Array of colors to alternate
  //   const words = sentence.split(' ');      // Split the sentence into words
  
  //   const styledWords = words.map((word, index) => {
  //     const color = colors[index % colors.length];  // Alternate colors
  //     return `<span style="color: ${color};">${word}</span>`;
  //   });
  
  //   const styledSentence = styledWords.join(' ');
  //   this.cachedStyledSentence = this.sanitizer.bypassSecurityTrustHtml(styledSentence);
  //   this.cachedSentence = sentence;
  
  //   return this.cachedStyledSentence;
  // }
  

 

  
  getclientbyid() {
    console.log(this.id)
    this.GeneralService.getclientbyid(this.id).then(res => {
      
      this.client = res;
      console.log(this.client)
      this.clientmodule = this.client[0].moudlerf
      console.log(this.clientmodule)
      this.clientmodule.map(element => {
        element['Words']=this.getStyledWords(element.name)
      });
      // this.clientmodule.forEach(element => {
      //   this.clientmodule.push(element)
      //   this.clientmodule.push(element)
      //   this.clientmodule.push(element)
      //   this.clientmodule.push(element)
      //   this.clientmodule.push(element)
      //   this.clientmodule.push(element)
      //   this.clientmodule.push(element)

      // });
    //   this.branches.forEach(brancheselement => {

    //     const brancesaudit = this.audit.filter(x=>x.branchid==brancheselement.id)
    //     this.branchesAudits.push({branchid:brancheselement.id,brancesaudit:brancesaudit})
    //     console.log(brancesaudit)
    //     if(brancesaudit.length!=0){
    //       let auditdate = new Date(Math.max.apply(null, brancesaudit.map(function (e) {
    //         return new Date(e.StartDate);
    //       })));
    //       this.latestdate = this.datepipe.transform(auditdate, 'yyyy-MM-dd').toString();
    //       this.lastauditbymodulebranch.push(brancesaudit.filter(x => x.StartDate === this.latestdate )[0]);

    //     }
        
    //     console.log(this.latestdate)
      
    //  });
    //  console.log(this.lastauditbymodulebranch,"lastauditbymodulebranch")
    //  this.lastauditbymodulebranch.forEach((lastauditbymodulebranchelement,bindex) => {
    //    this.lastauditbymodulebranch[bindex]["branchname"]=this.branches.filter(x=>x.id==lastauditbymodulebranchelement.branchid)[0].name
    //  });
//       this.clientmodule.forEach((element, index) => {
//         console.log(element)
//         this.auditmodulelabel = [];
//         this.auditbymodule = (this.audit.filter(x => x.module.id === element.id));
//         console.log(this.auditbymodule)
//         console.log(this.auditbymodule.length)
        
//        console.log(this.branchesAudits,"تست")
//         if (this.auditbymodule.length != 0) {

//           let auditdate = new Date(Math.max.apply(null, this.auditbymodule.map(function (e) {
//             return new Date(e.StartDate);
//           })));
//           this.latestdate = this.datepipe.transform(auditdate, 'yyyy-MM-dd').toString();
//           console.log(this.latestdate)
// this.lastauditbymodule = (this.audit.filter(x => x.module.id === element.id && x.StartDate === this.latestdate ));
//         //  this.branches.forEach(brancheselement => {
//         //    this.branchesAudits.filter()
//         //    this.auditofbranch
//         //  });
//                   console.log(this.lastauditbymodule);
//             this.allLastaudit.push(this.lastauditbymodule)
         
//           console.log(this.allLastaudit,"allLastaudit");
//           this.clientmodule[index]['auditmodule'] = this.auditbymodule;
//           this.clientmodule[index]['lastaudit'] = this.lastauditbymodulebranch;
  
//           console.log(this.lastauditbymodule, "here")
//           if (this.auditbymodule.length != 0) {
//             console.log("INTER hEEre")
//             //     this.startdate=this.lastauditbymodule[0].StartDate
//             this.clientmodule[index].lastaudit.forEach((lastauditelement,lastindex) => {
//               this.auditmodulelabel=[];
//               this.categories.push({categories:lastauditelement.module.categories,branchid:lastauditelement.branchid})
//               lastauditelement.module.categories.forEach(categorieselement => {
//               this.auditmodulelabel.push({"name": categorieselement.name, "value": categorieselement.score })
//               this.clientmodule[index].lastaudit[lastindex]['auditmodulelabel']=this.auditmodulelabel;
//               });
//             });
//             console.log(this.categories,"categories");
//         //   this.categories = this.clientmodule[index].lastaudit[0].module.categories;
        
//             // this.categories.forEach(element2 => {
//             //   element2.categories.forEach(element3 => {
//             //   this.auditmodulelabel.push({"name": element3.name, "value": element3.score })
//             //   });
//             //   //     this.average= this.lastauditbymodule[0].totalscore
//             //   // this.auditbymodulescore.push(element.score)

//             // });
//             console.log(this.auditmodulelabel,"this.auditmodulelabel")
//             //      this.auditbymodule.forEach(element => {
//             //  //console.log(element,"here")
//             //        this.auditmodulelabel.push(element.name)
//             //    });
//             console.log(this.auditbymodulescore)
//             this.lastaudittotalscore += element.score
            
//            // this.clientmodule[index]['auditmodulelabel']=this.auditmodulelabel;
           


//           }
//           console.log(this.lastauditbymodule)
//           console.log("clientmodule", this.clientmodule)
//           // this.auditbymodulecat=this.auditbymodule[0].module.categories
//           // this.categories.forEach(element => {
//           //   this.auditmodulelabel.push(element.name)
//           // });


//           this.single = this.auditmodulelabel
//           console.log("this.auditmodulelabel", this.auditmodulelabel)
//           console.log("single", this.single)
//           console.log("auditbymodulecat", this.auditbymodulecat)
//         }

//       });
// console.log(this.clientmodule);
    });

}
// AddModuel(){
//   this.GeneralService.addmodule();
// }
  ngOnInit() {
     this.getclientbyid();
  }

  
  
  onCardClick(card: any) {
    console.log(this.currentuser);
 if(this.currentuser.role == "cluster" || this.currentuser.role == "admin" ){
  this.router.navigate(['/dashboard/details', card.id]);
 }
 if(this.currentuser.role == "gm"){
  this.router.navigate(['/dashboard-gm/details', card.id]);
 }
 if(this.currentuser.role == "auditer"){
  this.router.navigate(['/dashboard-auditer/details', card.id]);
 }
  }
}



